// @react-native-firebase/messaging stand-in. Decision D8: no web push at
// launch; notifications reach web users by email plus the in-app polling
// notification center. Every call resolves to the "no permission / no token"
// path the app already handles.

type Unsubscribe = () => void;

export interface RemoteMessage {
  messageId?: string;
  data?: Record<string, string>;
  notification?: { title?: string; body?: string };
}

const AuthorizationStatus = {
  NOT_DETERMINED: -1,
  DENIED: 0,
  AUTHORIZED: 1,
  PROVISIONAL: 2,
  EPHEMERAL: 3,
} as const;

const instance = {
  async requestPermission(): Promise<number> {
    return AuthorizationStatus.DENIED;
  },
  async hasPermission(): Promise<number> {
    return AuthorizationStatus.DENIED;
  },
  async getToken(): Promise<string> {
    return '';
  },
  async deleteToken(): Promise<void> {},
  onMessage(_handler: (m: RemoteMessage) => unknown): Unsubscribe {
    return () => {};
  },
  onTokenRefresh(_handler: (t: string) => unknown): Unsubscribe {
    return () => {};
  },
  onNotificationOpenedApp(_handler: (m: RemoteMessage) => unknown): Unsubscribe {
    return () => {};
  },
  async getInitialNotification(): Promise<RemoteMessage | null> {
    return null;
  },
  setBackgroundMessageHandler(_handler: (m: RemoteMessage) => Promise<unknown>): void {},
  async registerDeviceForRemoteMessages(): Promise<void> {},
  isDeviceRegisteredForRemoteMessages: false,
};

type Messaging = typeof instance & { AuthorizationStatus: typeof AuthorizationStatus };

function messaging(): typeof instance {
  return instance;
}
(messaging as unknown as Messaging).AuthorizationStatus = AuthorizationStatus;

export { AuthorizationStatus };
export type FirebaseMessagingTypes = { RemoteMessage: RemoteMessage };
export default messaging as typeof messaging & { AuthorizationStatus: typeof AuthorizationStatus };
